export const errorHandler = (response: any) => {
  if (response?.data?.error && response?.data?.error?.code == 401) {
    localStorage.clear();
    window.location.href = '/';
    setTimeout(() => {}, 1000);
  }
};
